export default __webpack_public_path__ + "static/media/coincaI.98854aee.jpg";